import { render, staticRenderFns } from "./giveFraction.vue?vue&type=template&id=2a43d3bb&scoped=true"
import script from "./giveFraction.vue?vue&type=script&lang=js"
export * from "./giveFraction.vue?vue&type=script&lang=js"
import style0 from "./giveFraction.vue?vue&type=style&index=0&id=2a43d3bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43d3bb",
  null
  
)

export default component.exports